import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const brands = [
  "Nautica",
  "Ellesse",
  "Essentials",
  "883 Police",
  "FCUK",
  "French Connection",
  "Boohoo",
  "Erima",
  "Salming",
  "DKNY",
  "Nicce",
  "Cross Hatch",
  "Ed Hardy",
  "Juice",
  "Umbro",
];

export default function BrandSlideshow() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % brands.length);
    }, 2000); // change every 2 seconds
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative w-full h-64 md:h-96 overflow-hidden bg-brand text-white">
      <AnimatePresence mode="wait">
        <motion.div
          key={current}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.5 }}
          className="absolute inset-0 flex items-center justify-center px-6"
        >
          <span className="text-4xl md:text-7xl lg:text-8xl font-bold uppercase tracking-widest text-center leading-tight">
            {brands[current]}
          </span>
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
